module.exports = __webpack_public_path__ + "img/glassquality_5.89dd83f5.png";